import { combineReducers } from 'redux';
import authReducer from '@/util/redux/auth';
import historyReducer from '@/util/redux/history';
import careClientVisitorProfileReducer from './careClientVisitorProfile';
import careOrderBabyReducer from './careOrderBaby';
import careOrderBabyFormReducer from './careOrderBabyForm';
import remoteConfigReducer from './remoteConfig';
import trackerReducer from './tracker';
export default combineReducers({
    auth: authReducer,
    history: historyReducer,
    tracker: trackerReducer,
    careClientVisitorProfile: careClientVisitorProfileReducer,
    remoteConfig: remoteConfigReducer,
    careOrderBabyForm: careOrderBabyFormReducer,
    careOrderBaby: careOrderBabyReducer,
});
